import { OnInit, OnDestroy, Component, Optional, Inject } from '@angular/core';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-StatementFilter',
    templateUrl: './dojo-StatementFilter.component.html'
})
export class DojoStatementFilterComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    params: any;
    ismobile: boolean = false;
    constructor(private contextService: IContextService,
                private nxiRestService: NxiRestService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                @Optional() @Inject('AppSettings') appSettings: any) {
                    if (appSettings.deviceType === 'mobile') {
                        this.ismobile = true;
                    }
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;

            this.getManagedAccFilter();
        });
    }
    ngAfterViewInit(): void {
        if (this.ismobile) {
            document.getElementById('MA-Filter').style.display = 'none';
        }
    }
    handleManageAccountFilter(event: any) {
        console.log(event.checked);
        if (event.checked) {
            console.log('inside true');
            document.getElementById('MA-Filter').style.display = 'block';
        } else {
            document.getElementById('MA-Filter').style.display = 'none';
            console.log('inside false');
        }

    }
    ngOnDestroy(): void {
        console.log('In DojoStatementFilterComponent destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyStatementFilter();
        }
    }
    renderDojoWidget(MAFilterParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderStatementFilter(this.inputValue, MAFilterParams);
        }
    }

    getManagedAccFilter() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'managedAccFilter').subscribe(
                resp => {
                    console.log('Retrived common REST managedAccounts Grid params : ', resp.response);
                    if (resp.response) {
                        resp.response.storeUrl = this.nxiRestService.serviceUrl + resp.response.storeUrl;
                        resp.response.modAPIUrl = 'https://api-netxselect.wsodqa.com';
                        this.renderDojoWidget(resp.response);
                    }
                }
            );
        }
    }
}
